import FouSelect from 'components/form/fou-select/'
import FouSelectTags from 'components/form/fou-select-tags/'
import FouSelectFamilies from 'components/form/fou-select-families/'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container'
import FouExpand from 'components/tools/fou-expand/'
import FouPicture from 'components/tools/fou-picture/'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import { SubmissionObject, errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import { mapGetters } from 'vuex'
import { TimeoutUtil } from 'src/utils/helper/timer'
import Misc, { getRouteParam } from 'src/utils/helper/misc'
import TextEditor from 'components/form/text-editor/index.vue'
import AiTextEditor from 'components/form/ai-text-editor/index.vue'
import VSelect from 'components/form/v-select/index.vue'
import { useForm } from 'vee-validate'
import { isEmpty, isNull } from 'lodash'
import TextArea from 'src/components/form/new-text-area/index.vue'
import i18n from 'src/assets/i18n/i18n'
import DOMPurify from 'dompurify'
import {
  AI_SUGGESTION_ASSET_TYPES,
  AI_TAGS_FEEDBACK,
  DESCRIPTION_CHAR_LIMITS
} from 'src/utils/constants/common'
import { useAiTextEditor } from 'src/composables/useAiTextEditor'
import { MdSpinner, MdIconSmartStars, MdIconClose, MdButton } from '@antiqua-dls/vue-components'
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_NAMES, LINK_SECTION } from 'modules/adobe-cja/constants'

import Methods from './methods'

const { t } = i18n().global

export default {
  name: 'descriptions',

  components: {
    FouSelect,
    FouSelectTags,
    FouSelectFamilies,
    FouModal,
    FouContainer,
    FouPicture,
    FouExpand,
    MyfontsShortCircleIcon,
    ...FouGrid,
    FouGroup,
    TextEditor,
    TextArea,
    VSelect,
    AiTextEditor,
    MdSpinner,
    MdIconSmartStars,
    MdIconClose,
    MdButton
  },

  data() {
    const formats = ['bold', 'italic', 'link', 'list']
    const bannedWordsString = window.localStorage.getItem('banned_words');
    const bannedWords = bannedWordsString ? JSON.parse(bannedWordsString) : {};
    const {
      TagRestrictedDesignerNames: designerNames,
      TagRestrictedFontFormats: fontFormats,
      TagRestrictedFoundryNames: foundryNames,
      TagRestrictedTautology: tautology,
      TagRestrictedTypefaceNames: typefaceNames,
      TagRestrictedWords: restrictedWords,
      Conjunctions: conjunctions
    } = bannedWords;
    const submissionId = getRouteParam('submissions');

    return {
      searchCount: 0,
      fontFormats: fontFormats || [],
      famousTypeDesigner: designerNames || [],
      removeWords: restrictedWords || [],
      foundryName: foundryNames || [],
      typefaces: typefaceNames || [],
      tautology: tautology || [],
      conjunctions: conjunctions || [],
      descriptions: [],
      updatedDescription: '',
      bannedWordForTag: false,
      warningWordForTag: false,
      warningWords: [],
      category: FouSelectObject(),
      tags: FouSelectObject(),
      families: FouSelectObject(),
      familiesInputDelay: TimeoutUtil(),
      tagsInputDelay: TimeoutUtil(),
      familiesHideDrop: false,
      tagsHideDrop: false,
      locales: FouSelectObject(),
      item: SubmissionObject.getStep('descriptions'),
      languagesFeature: false,
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      isValidTagLength: false,
      isValidFamiliesLength: false,
      maxTagsReached: false,
      minTagsReached: false,
      tagsLength: 20,
      familiesLength: 50,
      options: {
        bounds: '.mt-wrapper',
        formats
      },
      siblings: [],
      tempRelatedFamilies: [],
      selectedFamily: {},
      isFamilySiblingModalVisible: false,
      tagsError: false,
      inValidTag: false,
      checkDesigner: false,
      allType: [],
      flag: false,
      enteredTag: '',
      warningWordsForTag: [],
      minTagLength: false,
      inValidChar: false,
      specialCharacters: [],
      _isValidating: false,
      aiTextEditorConfig: {
        aiEnabled: true,
        placeholder: {
          ai_disabled: this.$t('pages.aiTextEditor.placeholder_submission', { moduleName: 'font family' }),
          ai_enabled: this.$t('pages.aiTextEditor.ai_enabled_placeholder', { moduleName: 'font family' })
        },
        aiActions: {
          boostVisibility: true,
          polishWriting: true,
          fixGrammar: true,
          shortenText: true,
        },
        aiFooter: {
          tooltipDistance: 24,
        },
        assetType: AI_SUGGESTION_ASSET_TYPES.submission,
        assetId: submissionId,
        charLimits: DESCRIPTION_CHAR_LIMITS
      },
      aiTextEditorChangeCount: 0,
      aiTextEditorErrors: false,
      validationTriggerKey: null,
      isSuggestBannerDismissed: false,
      isFeedbackVisible: true,
      feedbackText: '',
      feedbackCharLimit: 3200,
      lastKnownBinaryCount: 0,
      aiTagsInitialized: false,
      pendingReaggregation: false,
      localExcludedAiTags: []
    }
  },

  setup() {
    const { errors: formError, validate } = useForm()
    const { submitAiTagsFeedback } = useAiTextEditor()
    return {
      formError,
      validate,
      submitAiTagsFeedback
    }
  },

  watch: {
    formError: {
      handler(newVal) {
        this.handleSubmissionErrors(newVal)
      },
      immediate: true
    },
    '$store.state.designers.tagValidation'(newVal) {
      this.checkDesigner = newVal;
      if (newVal) {
        this.removeTagsFromList(this.$store.state.designers.sameTagName);
      }
    },
    aiTextEditorErrors: {
      handler() {
        this.checkForAiTextEditorErrors()
      },
    },
    isSfdmsComplete(complete) {
      if (complete && !this.aiTagsInitialized) {
        this.onSfdmsCompleted()
      }
    },
    binaryList: {
      handler(newList) {
        const newCount = (newList || []).length
        if (this.lastKnownBinaryCount > 0 && newCount > this.lastKnownBinaryCount) {
          this.aiTagsInitialized = false
          this.isSuggestBannerDismissed = false
          this.pendingReaggregation = true
        }
        this.lastKnownBinaryCount = newCount
      },
      deep: true
    }
  },

  created() {
    this.addReadyState()
    this.setSubmissionBuild({
      before: this.buildSubmission
    })
    this.item.set({
      context: this
    })
    this.lastKnownBinaryCount = (this.binaryList || []).length
    this.localExcludedAiTags = this.submission?.excludedAiTags || []
    this.setLocales()
      .then(() => {
        return this.setDescriptions()
      })
      .then(() => {
        return this.setCategory()
      })
      .then(() => {
        return this.setTags()
      })
      .then(() => {
        return this.setFamilies()
      })
      .then(() => {
        this.ready.state = 'set'
        this.$events.$emit('on_load_validate_sections', 'description')
        if (this.isSfdmsComplete) {
          this.onSfdmsCompleted()
        }
      })

    let allTags = this.submissionTags.map(tag => tag.name)
    let allTagsArray = allTags.join(', ').split(', ')
    const bannedWordInfo = Misc.strikeThroughBadWords(allTags.join(' '), this.$store, 'fou-select', this.$route?.name, this.submission.foundry?.foundryId, [], [], true, allTagsArray);
    this.warningWords = bannedWordInfo.warningWordMatches?.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    this.warningWordForTag = bannedWordInfo.warningWordExist;
    this.$events?.$on('trigger:validate', () => {
      this.validationTriggerKey = Date.now() + '';
      this.validate()
    })
  },
  beforeUnMount() {
    this.$events?.$off('trigger:validate')
  },
  computed: {
    ...SubmissionComputed,
    ...Misc,
    ...mapGetters('tags', {
      'tagsList': ['list'],
      'tagsMinLength': ['minLength'],
      'tagsExcludeChar': ['excludeChar']
    }),
    ...mapGetters('families', {
      'familiesMinLength': ['minLength'],
      'familiesList': ['list'],
      'familiesExcludeChar': ['excludeChar'],
      'relatedFamilySiblings': ['relatedFamilySiblings']
    }),
    ...mapGetters('profile', {
      'foundries': ['foundries']
    }),
    ...mapGetters('contract', {
      'userFoundries': ['list']
    }),
    ...mapGetters('foundrySupport', {
      'foundryDetails': ['foundryDetails']
    }),
    ...mapGetters('binaries', {
      'binaryList': ['list']
    }),
    getSelectedFoundry() {
      if (this.foundries && this.foundries.length > 0) {
        return this.foundries.find(response => this.submission.foundry.name === response.name)
      } else if (this.userFoundries && this.userFoundries.length > 0) {
        return this.userFoundries.find(response => this.submission.foundry.name === response.name)
      } else {
        return this.foundryDetails
      }
    },
    tagRules() {
      const rules = ['script_tag_validate'];
      if (!this.tags?.values?.length && !this.visibleAiTags.length) {
        rules.unshift('submission_tag_required');
      }
      return rules.join('|');
    },
    siblingsText() {
      return this.siblings.map(res => res.label).join(', ')
    },
    tagDescription() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.descriptions.tags.description'), {
        ADD_ATTR: ['target'],
      })
    },
    tagStyleInfo() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.descriptions.tags.style_info'), {
        ADD_ATTR: ['target'],
      })
    },
    typefaceDescription() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.descriptions.description.tellusmore'), {
        ADD_ATTR: ['target'],
      })
    },
    relatedFamiliesDescription() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.descriptions.relatedFamilies.description'), {
        ADD_ATTR: ['target'],
      })
    },
    styleInfoDescription() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.descriptions.tags.style_info'), {
        ADD_ATTR: ['target'],
      })
    },
    isSfdmsComplete() {
      const binaries = this.binaryList || []
      if (binaries.length === 0) return false
      return binaries.every(binary => {
        const sectionsComplete = binary?.validationResult?.progress?.sectionsComplete || []
        return sectionsComplete.includes('onSfdmsComplete')
      })
    },
    isNewFamily() {
      return this.submission?.status === 'in_work'
    },
    aggregatedAiTags() {
      const binaries = this.binaryList || []
      const tagMap = new Map()

      binaries.forEach(binary => {
        const monotypeTags = binary?.monotypeTags || []
        monotypeTags.forEach(tag => {
          if (!tag?.name) return
          const normalizedName = tag.name.trim().toLowerCase()
          const existing = tagMap.get(normalizedName)
          const confidence = tag.confidence || 0
          if (!existing || confidence > existing.confidence) {
            tagMap.set(normalizedName, {
              name: tag.name.trim().charAt(0).toUpperCase() + tag.name.trim().slice(1),
              confidence
            })
          }
        })
      })

      const sorted = Array.from(tagMap.values()).sort((a, b) => b.confidence - a.confidence)
      return sorted
    },
    excludedAiTags: {
      get() {
        return this.localExcludedAiTags
      },
      set(tags) {
        this.localExcludedAiTags = [...tags]
        if (this.submission) {
          this.submission.excludedAiTags = this.localExcludedAiTags
        }
      }
    },
    visibleAiTags() {
      const excluded = (this.excludedAiTags || []).map(name => name.toLowerCase())
      const userTagNames = (this.tags?.values || []).map(t => t.label.toLowerCase())
      let filtered = this.aggregatedAiTags.filter(tag => {
        const lowerName = tag.name.toLowerCase()
        return !excluded.includes(lowerName) && !userTagNames.includes(lowerName)
      })

      if (this.isNewFamily) {
        const userCount = this.tags?.values?.length || 0
        const availableSlots = Math.max(0, this.tagsLength - userCount)
        if (filtered.length > availableSlots) {
          const overflow = filtered.slice(availableSlots)
          filtered = filtered.slice(0, availableSlots)
          const newExcluded = [...this.excludedAiTags]
          overflow.forEach(tag => {
            if (!newExcluded.some(e => e.toLowerCase() === tag.name.toLowerCase())) {
              newExcluded.push(tag.name)
            }
          })
          if (newExcluded.length !== this.excludedAiTags.length) {
            this.$nextTick(() => { this.excludedAiTags = newExcluded })
          }
        }
      }

      return filtered
    },
    hasAiTags() {
      return this.visibleAiTags.length > 0
    },
    showSuggestBanner() {
      return this.isSfdmsComplete &&
        this.aiTagsInitialized &&
        !this.hasAiTags &&
        this.aggregatedAiTags.length > 0 &&
        (this.tags?.values?.length || 0) < this.tagsLength &&
        !this.isSuggestBannerDismissed
    },
    totalTagCount() {
      return (this.visibleAiTags?.length || 0) + (this.tags?.values?.length || 0)
    }
  },

  methods: {
    ...Methods,
    ...SubmissionMethods,
    emitTagsCjaEvent(linkName, linkType = LINK_TYPES.BUTTON, extraPayload = {}) {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FONT_FAMILY_TAGS,
          linkSection: LINK_SECTION.SUBMISSIONS,
          linkName,
          linkType
        },
        ...extraPayload
      })
    },
    handleTagDescriptionClick(event) {
      const target = event.target.closest('a')
      if (target) {
        this.emitTagsCjaEvent(LINK_NAMES.CHECK_OUR_GUIDE)
      }
    },
    handleStyleInfoClick(event) {
      const target = event.target.closest('a')
      if (target) {
        this.emitTagsCjaEvent(LINK_NAMES.CLICK_HERE_WHY_20_TAGS)
      }
    },
    submitFeedback() {
      this.emitTagsCjaEvent(LINK_NAMES.SUBMIT_FEEDBACK)
      this.submitAiTagsFeedback({
        assetType: AI_TAGS_FEEDBACK.assetType.submission,
        assetId: this.aiTextEditorConfig.assetId,
        message: this.feedbackText,
        foundryId: this.submissionFoundryId
      })
      this.feedbackText = ''
      this.isFeedbackVisible = false
    },
    checkTagsValues() {
      return !isNull(this.tags.values) && this.tags.values.length > 0
    },
    removeTagsFromList(tagsToRemove) {
      this.tags.values = this.tags.values.filter(tag => !tagsToRemove.includes(tag.label));
      this.$store.commit('designers/setSameTagName', []);
      this.$store.commit('designers/setTagValidation', false);
      this.tags.state = 'set';
      this.tags.update(this.tags.values, this.commitChange);
      this.$refs?.tagsSelect?.onSearchBlur();
    },
    onSearchBlur() {
      if (isEmpty(this.tags.values)) {
        this.$refs.tagsSelect._value = []
        this.tags.values = []
      }
      this.validate()
      this.tags.options = []
    },
    handleSubmissionErrors(errors) {
      for (const key in errors) {
        submissionErrors.value.push({ [key]: errors[key] })
      }
      this.checkForAiTextEditorErrors()
      this.checkIfDescriptionSectionErrorStillExists(errors)
    },
    checkIfDescriptionSectionErrorStillExists(errors) {
      const descriptionSectionErrors = ['tags descriptions']
      for (const errorName of descriptionSectionErrors) {
        if (!Object.hasOwn(errors, errorName)) {
          submissionErrors.value = submissionErrors.value.filter(error => !Object.keys(error).includes(errorName))
        }
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
    },
    checkForAiTextEditorErrors() {
      const submissionErrorsArray = submissionErrors.value.filter(error => !Object.keys(error).includes('descriptions'))
      if (this.aiTextEditorErrors) {
        submissionErrorsArray.push({
          'descriptions': t('pages.submissions.components.descriptions.description.fix_descriptions_errors')
        })
      }
      submissionErrors.value = submissionErrorsArray;
    }
  }
}
